/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { SERVICE_REQUEST_LABEL } from '../constants/entityLabels';

const ApiDocs = () => {
  return (
    <div className="space-y-4">
      <div className="mb-4">
        <h1 className="page-title">API Documentation</h1>
        <p className="page-subtitle">Reference for the Login and {SERVICE_REQUEST_LABEL.singular} APIs.</p>
      </div>

      <div className="card-premium rounded-xl glass-panel border border-base-content/10 overflow-hidden">
        <SwaggerUI url="/docs/openapi.json" supportedSubmitMethods={[]} />
      </div>
    </div>
  );
};

export default ApiDocs;
